<script setup lang="ts">
import { useRoute, useRouter } from 'vue-router'
import { CannotCreateEligibilitySubmission, CannotGetQuestions } from '../Errors'
import { Action, Actor, enrollmentTracking } from '../Integrations/Tracking'
import { installGtm } from '../Integrations/gtm'
import { useEligibilitySubmissionStore } from '../Stores/eligibilitySubmission'
import { useQuestionStore } from '../Stores/question'

const props = defineProps<{
    uuid: string
}>()

enum RedirectedFrom {
    Setle = 'setle',
}

const { query } = useRoute()
const router = useRouter()

const eligibilitySubmissionStore = useEligibilitySubmissionStore()
const questionStore = useQuestionStore()

if (query.from === RedirectedFrom.Setle) {
    enrollmentTracking.track(Actor.Homeowner, Action.RedirectFromSetle)
}

try {
    await eligibilitySubmissionStore.continueFromSubmission(query.token as string, props.uuid)

    if (eligibilitySubmissionStore.error) {
        throw new CannotCreateEligibilitySubmission('Error creating eligibility submission')
    }

    await questionStore.getQuestions(eligibilitySubmissionStore.eligibilitySubmission.campaignId)

    if (questionStore.error) {
        throw new CannotGetQuestions('Error getting questions')
    }

    const advisedTechniques =
        eligibilitySubmissionStore.eligibilitySubmission.advisedTechniques || []
    if (advisedTechniques.length > 0) {
        questionStore.adviseTechniques(advisedTechniques)
    }

    if (eligibilitySubmissionStore.eligibilitySubmission.responses?.length) {
        questionStore.fillAnswers(eligibilitySubmissionStore.eligibilitySubmission.responses)
    }

    installGtm(
        eligibilitySubmissionStore.eligibilitySubmission.campaign.advertising.googleTagManagerId
    )

    if (
        eligibilitySubmissionStore.campaignSwapPIScreen &&
        !eligibilitySubmissionStore.eligibilitySubmission.address?.postalCode
    ) {
        router.push({
            name: 'postal-code',
            query: { campaignId: eligibilitySubmissionStore.eligibilitySubmission.campaignId },
            replace: true,
        })
    } else {
        router.push({
            name: 'home',
            query: { campaignId: eligibilitySubmissionStore.eligibilitySubmission.campaignId },
            replace: true,
        })
    }
} catch (error) {
    if (error instanceof CannotCreateEligibilitySubmission || error instanceof CannotGetQuestions) {
        router.push({ name: 'error' })
    }
}
</script>

<template>
    <div />
</template>
